module.exports = __webpack_public_path__ + "static/media/leak-pod-offline.5bc6877b.svg";